module.exports = __webpack_public_path__ + "static/img/product_images_big01_h5_zh.b433687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big01_h5_zh.png
// module id = 3e0K
// module chunks = 34